export default {
  economyTable: {
    event: 'SỰ KIỆN',
    importance: 'ẢNH HƯỞNG',
    actual: 'THỰC TẾ',
    forecast: 'DỰ BÁO',
    previous: 'KỲ TRƯỚC',
  },
  listImportance: {
    Nomal: 'TRUNG BÌNH',
    Low: 'THẤP',
    High: 'CAO',
  },
  listLabel: {
    importance: 'ẢNH HƯỞNG',
    weekly: 'Hằng Tuần',
    nextWeek: 'Tuần Tới',
    prevWeek: 'Tuần Trước',
    unitTitleNote:
      '*Miễn Trừ Trách Nhiệm: Nhà đầu tư cần lưu ý rằng mức độ ảnh hưởng của các sự kiện chỉ được sử dụng với mục đích tham khảo',
    unitTitleNote1:
      '*Miễn trừ trách nhiệm: Nhà đầu tư cần lưu ý rằng mức độ tin cậy của các tin đồn phụ thuộc vào đánh giá chủ quan từ FiinTrade và chỉ được sử dụng cho mục đích tham khảo.',
  },
  importance: {
    LOW: 'Thấp',
    MED: 'Trung Bình',
    HIGH: 'Cao',
  },
  originalPost: 'Original Post VI',
  fiinGroupReview: 'FiinGroup Review VI',
};
